import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';
export const GET_COMPATIBILITY = registerQuery({
  fieldName: 'compatibility',
  args: [],
  fetcher: ecosystemClient.getCompatibility
});